import {StyleSheet, Platform} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (rowItem) are preserved — the factory returns them closed over the theme's
// colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      marginHorizontal: 24,
      marginTop: 16,
      borderRadius: 16,
      padding: 12,
      backgroundColor: colors.surface,
      shadowColor: colors.shadow,
      shadowOpacity: 0.12,
      shadowRadius: 30,
      shadowOffset: {width: 0, height: 30},
      elevation: 30,
    },
    productInfoView: {
      flexDirection: 'row',
    },
    productImage: {
      height: 74,
      width: 74,
      borderRadius: 8,
    },
    titleContainer: {
      marginLeft: 16,
      flex: 1,
      justifyContent: 'space-between',
    },
    priceContainer: {
      paddingHorizontal: 8,
      paddingVertical: 5,
      borderRadius: 8,
      backgroundColor: colors.backgroundMuted,
      alignSelf: 'flex-start',
    },
    marginVertical16: {
      marginVertical: 16,
    },
    qtyContainer: {
      marginHorizontal: 0,
      borderWidth: 1,
      borderRadius: 16,
      marginTop: 8,
      borderColor: colors.borderMuted,
      flexDirection: 'row',
    },
    arrowImgContainer: {
      marginHorizontal: Platform.OS === 'web' ? 0 : 19,
      marginVertical: Platform.OS === 'web' ? 0 : 24,
      paddingVertical: Platform.OS === 'web' ? 24 : 0,
      paddingHorizontal: Platform.OS === 'web' ? 24 : 0,
      alignItems: 'center',
      justifyContent: 'center',
    },
    qtyTextContainer: {
      flex: 1,
      borderLeftWidth: 1,
      borderRightWidth: 1,
      borderLeftColor: colors.borderMuted,
      borderRightColor: colors.borderMuted,
      alignItems: 'center',
      justifyContent: 'center',
    },
    colorTextContainer: {
      flex: 1,
      marginLeft: 16,
      justifyContent: 'center',
    },
    rowContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    rowItem: leftMargin => ({
      flex: 1,
      marginLeft: leftMargin,
    }),
  });

export default makeStyles;
